export enum LessonType {
    Lesson = 'Lesson',
    PMLesson = 'PMLesson',
    XLesson = 'XLesson',
}
